import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, input, output, ViewChild } from '@angular/core';
import { BENEFITS_TAG } from '@app/utils/constants/tags';
import { ExperienceStyle } from '@ess-front/shared';

@Component({
  selector: 'ess-experience-title',
  templateUrl: './experience-title.component.html',
  styleUrls: ['./experience-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ExperienceTitleComponent implements AfterViewInit {
  category = input.required<string>();
  city = input.required<string | null>();
  experienceStyle = input.required<string>();
  neighborhood = input.required<string>();
  title = input.required<string>();
  benefits = input.required<string>();

  titlePosition = output<number>();

  benefitsTag = BENEFITS_TAG;

  @ViewChild('titleElement') titleElement: ElementRef | null = null;

  ExperienceStyle = ExperienceStyle;

  ngAfterViewInit(): void {
    this.titlePosition.emit(this.titleElement?.nativeElement.getBoundingClientRect().top);
  }
}
